import React from 'react';
import useIsWebView from '@app/shared/hooks/useIsWebView';
import { DeepLink } from '@app/shared/utils/deeplink';
import { getWindow } from '@app/shared/utils/window';
import FeedbackPage from '@pedidosya/web-fenix/system/FeedbackPage';
import FooterButton from '@pedidosya/web-fenix/system/FooterButton';
import { useFenixIllustration } from '@pedidosya/web-fenix/utils/image';
import { Constants } from '@app/shared/config/Constants';

export const ErrorPage = () => {
  const isWebView = useIsWebView();
  const deeplink = DeepLink.home.ios;
  const wn = getWindow();
  const ilustration = useFenixIllustration(Constants.GENERAL_ERROR_ILUSTRATION);
  const onBack = () => {
    if (isWebView) {
      wn!.location.href = deeplink;
    } else {
      wn!.location.href = '/';
    }
  };

  const retry = () => {
    wn!.location.reload();
  };

  return (
    <FeedbackPage title="Lo sentimos, algo salió mal" imageSrc={ilustration as string}>
      <FeedbackPage.TopBar
        left={isWebView ? 'empty' : 'icon'}
        right="empty"
        middle="empty"
        onGoBack={onBack}
      />
      <FeedbackPage.FooterButton>
        <FooterButton.Button
          fullWidth
          hierarchy="primary"
          label="Volver a intentar"
          onClick={retry}
          size="large"
        />
        <FooterButton.Button
          fullWidth
          hierarchy="secondary"
          label="Ir al inicio"
          onClick={onBack}
          size="large"
        />
      </FeedbackPage.FooterButton>
    </FeedbackPage>
  );
};
